export default async function updateCampaignSection ({ commit, getters }, payload) {
  const { data, section, vm } = payload

  const { config, flat, userPreferences } = data

  const currentCampaign = getters.currentCampaign

  if (config) {
    if (section === 'campaignData') {
      // If market changed, change inherited market-based sections
      const oldMarket = currentCampaign.config.campaignData.markets.selected
      const newMarket = config.markets.selected

      const oldChannels = JSON.stringify(currentCampaign.config.campaignData.campaignChannel.selected)
      const newChannels = JSON.stringify(config.campaignChannel.selected)

      const oldBrands = JSON.stringify(currentCampaign.config.campaignData.campaignBrands.selected)
      const newBrands = JSON.stringify(config.campaignBrands.selected)

      if (oldMarket !== newMarket || oldChannels !== newChannels || oldBrands !== newBrands) {
        const targetSource = config.targetSource.selected
        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: {} })
        const brandsRules = []
        if (targetSource === 'contacts_leads') {
          brandsRules.push(
            [
              {
                field: 'brand',
                table: 'perm',
                type: 'rule',
                operator: 'in',
                values: config.campaignBrands.selected
              },
              {
                field: 'brand',
                table: 'lead',
                type: 'rule',
                operator: 'in',
                values: config.campaignBrands.selected
              }
            ]
          )
        }

        const channelsRules = config.campaignChannel.selected.map(channel => {
          let rules
          switch (channel) {
            case 'document':
              rules = [
                {
                  field: 'address',
                  operator: 'isnotnull',
                  table: 'contact'
                },
                {
                  field: 'privacy_mail',
                  operator: 'eq',
                  table: 'contact',
                  values: 'G'
                }
              ]
              break
            case 'call':
              rules = [
                {
                  field: 'phone_number',
                  operator: 'isnotnull',
                  table: 'contact'
                },
                {
                  field: 'privacy_tel',
                  operator: 'eq',
                  table: 'contact',
                  values: 'G'
                }
              ]
              break
            case 'sms':
              rules = [
                {
                  field: 'mobile_number',
                  operator: 'isnotnull',
                  table: 'contact'
                },
                {
                  field: 'privacy_sms',
                  operator: 'eq',
                  table: 'contact',
                  values: 'G'
                }
              ]
              break
            case 'email':
              rules = [
                {
                  field: 'email',
                  operator: 'isnotnull',
                  table: 'contact'
                },
                {
                  field: 'privacy_email',
                  operator: 'eq',
                  table: 'contact',
                  values: 'G'
                }
              ]
              break
            default:
          }
          return rules
        })
          .flat()
          .map(r => {
            return {
              field: r.field,
              table: r.table,
              type: 'rule',
              operator: r.operator,
              values: r.values
            }
          })

        const marketRules = [
          {
            field: 'cod_market',
            operator: 'eq',
            table: 'contact',
            type: 'rule',
            values: config.markets.selected
          }
        ]

        if (targetSource === 'contacts_leads') {
          marketRules.push({
            field: 'cod_market',
            operator: 'eq',
            table: 'perm',
            type: 'rule',
            values: config.markets.selected
          })
          marketRules.push(
            {
              field: 'cod_market',
              operator: 'eq',
              table: 'lead',
              type: 'rule',
              values: config.markets.selected
            }
          )
        }

        const filters = {
          selected: {},
          standard: {
            id: 'item_standard',
            segmentName: vm.$t('campaignDesigner.targetDefinition.standardSegment'),
            type: 'group',
            operator: 'AND',
            conditions: [
              ...marketRules,
              ...brandsRules,
              ...channelsRules
            ].flat()
          }
        }

        commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: _.cloneDeep(filters) })
      }
    }
    if (section === 'filters') {
      const oldFilters = JSON.stringify(getters.state.currentCampaignConfig.filters)
      const newFilters = JSON.stringify(config)

      if (oldFilters !== newFilters) {
        commit('CLEAR_PREVIEW')
      }

      commit('UPDATE_CURRENT_CAMPAIGN_CONFIG_SECTION', { section: 'filters', data: config })
    }

    commit('UPDATE_CAMPAIGN_CONFIG_SECTION', { section, data: _.cloneDeep(config) })
  }

  if (flat) {
    Object.keys(flat).forEach(key => {
      commit('SET_CAMPAIGN_FIELD', { name: key, value: _.cloneDeep(flat[key]) })
    })
  }

  if (userPreferences) {
    Object.keys(userPreferences)
      .forEach(field => {
        commit('SET_USER_PREFERENCE', { name: field, value: _.cloneDeep(userPreferences[field]) })
      })
  }
}
